/**
 *    从native jsbridge方法来封装post.get.put等请求，统一用http请求方法
 */
import JsBridge from "@/api/jsbridge/jsbridge";
import InterceptorManager from "@/api/http/fetch/interceptorManager";
import cancelToken from "@/api/http/fetch/cancelToken";

export class Http extends JsBridge {
  public static CancelToken = cancelToken;
  public defaultParams: any; //先必须声明类型，constructor内部才能声明实例的新的属性或者方法
  public chain: any;
  public interceptors: {
    request: any;
    response: any;
  };
  constructor() {
    /**
     * 代表了父类的构造函数 类似于 JsBridge.prototype.constructor.call(this); super内部的this指向子类
     * 用super赋值的时候,由于this指向子类的实例，super就相当于了this， super.x == this.x
     */
    super();
    this.defaultParams = {
      timeout: 15000,
      method: "GET"
    };
    this.interceptors = {
      request: new InterceptorManager(),
      response: new InterceptorManager()
    };
  }

  public request(config: any) {
    config = {
      ...this.defaultParams,
      ...config
    };
    config.method = config.method.toUpperCase();
    // Hook up interceptors middleware
    const chain = [
      this.dispatchRequest,
      (error: any) => {
        return error;
      }
    ];
    let promise = Promise.resolve(config);

    this.interceptors.request.handlers.forEach((interceptor: any) => {
      chain.unshift(interceptor.fulfilled, interceptor.rejected);
    });

    this.interceptors.response.handlers.forEach((interceptor: any) => {
      chain.push(interceptor.fulfilled, interceptor.rejected);
    });
    //shift()删除元素中第一个，并返回第一个元素，将config传输第一个函数作为参数：
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }
    return promise;
  }

  public $get(params: any = this.defaultParams) {
    /**
     * 在普通方法中super指向了父类的<原型对象>,所以父类实例上的方法和属性找不到；super内部this指向子类实例
     * 在静态方法中指向了父类
     * import:super必须显式的作为函数还是对象去使用
     */
    return new Promise(async (resovle, reject) => {
      try {
        const response = await super.http({
          ...this.defaultParams,
          ...params
        });
        resovle(response);
      } catch (error) {
        reject(error);
      }
    });
  }

  public $post(params: any) {
    return new Promise(async (resovle, reject) => {
      try {
        const response = await super.http({
          ...this.defaultParams,
          ...{ method: "POST" },
          ...params
        });
        resovle(response);
      } catch (error) {
        reject(error);
      }
    });
  }

  public throwIfCancellationRequested(requestConfig: any) {
    if (requestConfig.cancelToken) {
      requestConfig.cancelToken.throwIfRequested();
    }
  }

  public dispatchRequest = async (config: any) => {
    // this.throwIfCancellationRequested(config);
    //native http way:
    try {
      let result: any;
      if (config.cancelToken) {
        // Handle cancellation
        result = await Promise.race([
          config.cancelToken.promise,
          this.$get(config)
        ]);
      } else {
        result = await this.$get(config);
      }
      if (config.userId) {
        //为了在回调中知道从哪个用户Id来的请求
        result = {
          ...result,
          userId: config.userId
        };
      }
      if (config.handleErr) {
        //为了在回调中handleErr
        result = {
          ...result,
          handleErr: config.handleErr
        };
      }

      if (config.fromWorker) {
        //为了在回调中知道fromWorker
        result = {
          ...result,
          handleErr: config.fromWorker
        };
      }

      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  };
}
//将cancelToken方法挂载在Http的静态方法下：

const http = new Http();
export default http;
